import styled from "styled-components";

import { Drawer } from "@libraries/mui";

const Container = styled(Drawer)`
  > .MuiDrawer-paper {
    background-color: transparent !important;
  }
`;

const Content = styled.div`
  width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 15px 10px;
  transition: all 0.5s;
  overflow: auto;
  overflow-x: hidden;
  gap: 25px;
  background-color: ${(props) => props.theme.colors.primary};
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 1.5rem;
  color: white;
`;

const Menus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.5s;
  overflow: auto;
  overflow-x: hidden;
  gap: 10px;
`;

export { Container, Content, Title, Menus };
